/* Documentation available at https://github.com/andrelandgraf/react-datalist-input **/
import React, { useState } from 'react';
import Text from '../text/index.jsx';
import { CheckIcon } from '../icons/index.js';

const Option = ({ id, label, image, onOptionSelect, isChecked, highlightOnHover, withImage }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const onClick = () => {
    onOptionSelect({ id, label });
  };

  const styledLabel = label.split(' ').map(n => n.charAt(0)).join('').toUpperCase();

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      style={{
        ...styles.container,
        ...isHovered && highlightOnHover && styles.containerHovered,
      }}
    >
      {withImage &&
        <div style={{ backgroundImage: image ? `url("${image}")` : 'none', ...styles.image }}>
          {!image && styledLabel}
        </div>}
      <Text style={{ ...styles.label, color: isHovered && highlightOnHover ? '#fff' : '#000' }} element="h2">{label}</Text>
      <div style={{ ...styles.checkmark, ...isChecked && styles.checkmarkChecked }}>
        {isChecked && <CheckIcon type="small" color="white" style={styles.check} />}
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '10px 0',
  },
  containerHovered: {
    backgroundColor: '#000',
  },
  image: {
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    width: 40,
    height: 40,
    marginRight: 8,
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#393939',
    color: '#fff',
  },
  check: {
    marginRight: 1 ,
  },
  checkmark: {
    width: 20,
    height: 20,
    border: '1px solid black',
    backgroundColor: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkmarkChecked: {
    backgroundColor: 'black',
  },
  label: {
    width: '70%',
    flex: 1,
  },
};
export default Option;
